import { render, staticRenderFns } from "./ListaRezultata.vue?vue&type=template&id=74f19ea8&scoped=true&"
import script from "./ListaRezultata.vue?vue&type=script&lang=js&"
export * from "./ListaRezultata.vue?vue&type=script&lang=js&"
import style0 from "./ListaRezultata.vue?vue&type=style&index=0&id=74f19ea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f19ea8",
  null
  
)

export default component.exports